import {
  Component,
  forwardRef,
  Inject,
  OnInit,
  ComponentFactoryResolver,
  Output,
  EventEmitter,
  Input,
  ViewChildren,
  QueryList,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';
import { DataEntityInputComponent } from '../../data-entity-input/data-entity-input.component';
import {
  Actions,
  Contractor,
  ContractorRegistration,
  ContractorType
} from 'src/app/models';
import {
  debounceTime,
  distinctUntilChanged,
  Observable,
  of,
  Subject
} from 'rxjs';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  SelectContractorData,
  SelectContractorDataEntity
} from 'src/app/models/data-entities/select-contractor-data-entity';
import {
  ContractorService,
  SecurityService,
  Utilities,
  WorkflowContextService,
  WorkflowService
} from 'src/app/services';
import {
  ItemSearchOptionField,
  ItemSearchOptionFieldOption
} from 'src/app/components/filter-list/models/filterClasses';
import { RegistrationStatus } from 'src/app/models/registration';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ButtonStyle } from 'src/app/components/system/modal-confirm/modal-confirm.component';
import { ContractorCustomFieldListComponent } from 'src/app/components/contractors/contractor-custom-field-list/contractor-custom-field-list.component';
import { LayoutService } from 'src/app/services/layout.service';
// TODO: update this path to match where common-dropdown lives in your project
import { DropdownOption } from 'src/app/components/common/common-dropdown/common-dropdown.component.model';
import { ActivatedRoute, Router } from '@angular/router';
import { applicantHomeRoutesNames } from 'src/app/services/mock-data/applicant-home-constants/applicant-home-constants';

@Component({
  selector: 'wm-select-contractor-data-entity-input',
  templateUrl: './select-contractor-data-entity-input.component.html',
  styleUrl: './select-contractor-data-entity-input.component.css',
  standalone: false
})
export class SelectContractorDataEntityInputComponent
  extends DataEntityInputComponent
  implements OnInit, OnDestroy {
  @Input() showLabel: boolean = true;
  @Output() selected: EventEmitter<SelectContractorData> = new EventEmitter<
    SelectContractorData
  >();
contractorTypeDropdownOptions: DropdownOption[] = [];

  constructor(
    public layoutService: LayoutService,
    @Inject(forwardRef(() => ContractorService))
    public _contractorSvc: ContractorService,
    resolver: ComponentFactoryResolver,
    private context: WorkflowContextService,
    private _toastr: ToastrService,
    @Inject(forwardRef(() => SecurityService))
    private _securitySvc: SecurityService,
    ref: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private workflowService: WorkflowService
  ) {
    super(layoutService, resolver, ref, context);

    layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });
  }

  contractorType: ContractorType;
  contractorTypeId: string;
  public sortField = '';
  public sortDescending: boolean;
  registrations: ContractorRegistration[];
  contractor: Contractor;

  public searchText: string;
  public searchTextChanged: Subject<string> = new Subject<string>();
  entity: SelectContractorDataEntity;
  ButtonStyle = ButtonStyle;
  RegistrationStatus = RegistrationStatus;
  @ViewChildren('customFields') customFieldComponents: QueryList<
    ContractorCustomFieldListComponent
  >;
  registerContractorTypeId: string;
  canApplyOnBehalfOf: boolean;

  entityForm: UntypedFormGroup;
  templateForPermitForm: boolean = false;
  notInListCtl: AbstractControl;
  selectRegCtl: AbstractControl;
  contractorValueCtl: AbstractControl;
  entityCtl: AbstractControl;
  availableRegistrations: any[];
  contractorTypeDetails: {
    [key: string]: {
      id: string;
      name: string;
      registerWorkflowId: string;
      renwalWorkflowId: string;
    };
  };
  isMyselfOptionDisabled: boolean = false;

 contractorRadioData: {
    options: { label: string; value: string; disabled?: boolean }[];
    required: boolean;
    direction: string;
    value?: string;
  } = {
    options: [
      { label: 'Myself', value: 'myself', disabled: false },
      { label: 'Other Contractor', value: 'otherContractor' }
    ],
    required: true,
    direction: 'row'
  };



  public pagination: {
    pageCount?: number;
    pageNumber?: number;
    perPage?: number;
  } = {
    pageNumber: 0,
    pageCount: 0,
    perPage: 10
  };
  searching = false;

  get pages() {
    const pages = [];
    for (let index = 0; index < this.pagination.pageCount; index++) {
      pages.push(index + 1);
    }

    return pages;
  }

  get getTypeNameList() {
    return this.entity.contractorTypeIds && this.contractorTypeDetails
      ? this.entity.contractorTypeIds
          .map(id => this.contractorTypeDetails[id].name)
          .join(' OR ')
      : '';
  }

  // Added for templateForPermitForm=true register confirm modal: feeds
  // wm-common-dropdown with the same contrator type choices the native
  // <select> used, without touching the non-template markup/logic.


  onRegisterContractorTypeChange(value: string): void {
    this.registerContractorTypeId = value as string;
  }

  cancelRegistrationUpdate(r) {
    r.updatingRequirements = false;
  }

  openRegister() {
    this.registerContractorTypeId = this.entity.contractorTypeIds[0];
  }

  saveRegistrationUpdate(r) {
    r.savingRequirements = true;
    if (this.customFieldComponents) {
      this.customFieldComponents.forEach(r => r.persistValues());
    }

    this._contractorSvc
      .saveContractorRegistrationRequirementFields(
        r.requirementCustomFields,
        r.contractorId
      )
      .subscribe(
        () => {
          this._contractorSvc
            .getContractorRegistration(r.registrationId)
            .subscribe(rs => {
              r.savingRequirements = false;
              r.updatingRequirements = false;
              r.status = rs.status;
            });
        },
        () => {
          r.savingRequirements = false;
          r.updatingRequirements = false;
        }
      );
  }

  registerForContractor(contractorTypeId) {
        if(!this.templateForPermitForm){
            if (this.context.isTestApplication) {
              window.open(
                Utilities.getRootURL() +
                  '/home/StartWorkflowApplication?workflowId=' +
                  this.contractorTypeDetails[contractorTypeId].registerWorkflowId +
                  '&isTestApplication=true',
                '_blank'
              );
            } else {
              window.location.href =
                Utilities.getRootURL() +
                '/home/StartWorkflowApplication?workflowId=' +
                this.contractorTypeDetails[contractorTypeId].registerWorkflowId;
            }
      }
      else{
        this.launchWorkflow(
          this.contractorTypeDetails[contractorTypeId].registerWorkflowId
        );
      }
  }

  private launchWorkflow(workflowId: string): void {
    // this.context.isJanusChildWorkflowCalled$.emit(true);
    const startingActivityId = '1';
const isTestApplication = false;

    const originApplicationId = this.context.applicationId;
      this.workflowService
          .startApplication(workflowId, isTestApplication, startingActivityId)
          .subscribe({
            next: (response: any) => {
              const startingActivityId = '1';

              const applicationId =
                response?.applicationId ??
                response?.applicationID ??
                response?.applicationld;

    this.context.applicationId$.emit(applicationId);
              if (!applicationId) {
                return;
              }

               if (
                  this.context.janusLayout === 'staff' &&
                  this.router.url.includes('workflow-applications')
                ) {
                  if (this.context.applicationViewType === 'overlay') {
                    this.context.linkedApplicationOriginId = originApplicationId;
                    this.context.isLinkedApplicationLaunch = true;

                    this.router.navigate(
                      [
                        'admin',
                        'jurisdiction',
                        this.context.client.id,
                        'department',
                        this.context.staffDepartmentId,
                        'workflow-applications',
                        'data',
                        'application',
                        applicationId
                      ],
                      {
                        state: {
                          startingActivityId,
                          useNewLayout: this.context?.useNewLayout || false
                        }
                      }
                    );
                  } else if (this.context.applicationViewType === 'inline') {
                    const currentId = this.route.snapshot.queryParamMap.get('id');
                    const currentPage = this.route.snapshot.queryParamMap.get('p');
const source = this.route.snapshot.queryParamMap.get('s');
                    this.router.navigate(
                      [
                        'admin',
                        'jurisdiction',
                        this.context.client.id,
                        'department',
                        this.context.staffDepartmentId,
                        'workflow-applications',
                        'data'
                      ],
                      {
                        queryParams: {
                          id: currentId,
                          p: currentPage,
                          isLinkedApp: 1,
                          cid: applicationId,
                          showAppView: 1,
                          s:source
                        },
                        queryParamsHandling: 'replace'
                      }
                    );
                  }
                } else if (this.context.janusLayout === 'applicant') {
                  const urlSegments = this.router.url.split('/');

                  const isApplicationRoute = urlSegments.includes(
                    applicantHomeRoutesNames.application.route
                  );

                  const lastRoute = isApplicationRoute
                    ? applicantHomeRoutesNames.applyForPermit.route
                    : applicantHomeRoutesNames.myApplications.route;
                  const deptIndex = urlSegments.indexOf('department');
                  const deptId = deptIndex !== -1 ? urlSegments[deptIndex + 1] : null;

                  this.context.linkedApplicationOriginId = originApplicationId;
                  this.context.linkedApplicationOriginDeptId = deptId;
                  this.context.linkedApplicationOriginRoute = lastRoute;
                  this.context.isLinkedApplicationLaunch = true;

                  console.log(this.context.linkedApplicationOriginId, this.context.linkedApplicationOriginDeptId, this.context.isLinkedApplicationLaunch);
try {
  sessionStorage.setItem(
    `wm.linkedAppOrigin.${applicationId}`,
    JSON.stringify({ originId: originApplicationId, originDeptId: deptId, originRoute: lastRoute })
  );
} catch {}

                  if (isApplicationRoute && deptId) {
                    this.router.navigate(
                      [
                        '/jurisdiction',
                        this.context.client.id,
                        applicantHomeRoutesNames.root,
                        lastRoute,
                        'department',
                        deptId,
                        'application',
                        applicationId
                      ],
                      {
                        queryParams: {
                          isLinkedApp: 1,
                          originId: originApplicationId,
                          originDeptId: deptId,
                          originRoute: lastRoute
                        },
                        queryParamsHandling: 'merge'
                      }
                    );
                  } else {
                    this.router.navigate(
                      [
                        '/jurisdiction',
                        this.context.client.id,
                        applicantHomeRoutesNames.root,
                        lastRoute,
                        'workflow-application',
                        applicationId
                      ],
                      {
                        queryParams: {
                          isLinkedApp: 1,
                          originId: originApplicationId,
                          originRoute: lastRoute
                        },
                        queryParamsHandling: 'merge',
                        state: {
                          startingActivityId,
                          useNewLayout: this.context?.useNewLayout || false
                        }
                      }
                    );
                  }
                }
            },
            error: err => {
              if (err?.error) {
              }
            }
          });


  }

  renewRegistration(registrationId) {
    if(!this.templateForPermitForm){
    if (this.context.isTestApplication) {
      window.open(
        Utilities.getRootURL() +
          '/home/StartRegistrationRenewal?registrationId=' +
          registrationId +
          '&isTestApplication=true',
        '_blank'
      );
    } else {
      window.location.href =
        Utilities.getRootURL() +
        '/home/StartRegistrationRenewal?registrationId=' +
        registrationId;
    }
  }
      else{
        this.launchWorkflow(
          this.contractorTypeDetails[registrationId].registerWorkflowId
        );
      }
  }

  updateRequirements(registration) {
    registration.updatingRequirements = true;
  }

  async selectRegistration(reg) {
    this.contractor = null;
    this.contractorValueCtl.setValue('myself');
    this.entity.inputData.reset();

    this.entity.inputData.notInList = false;
    this.entity.inputData.selectedContractorBusinessName = reg.businessName;
    this.entity.inputData.selectedContractorId = reg.contractorId;
    this.entity.inputData.selectedRegistrationId = reg.registrationId;
    this.entityCtl.setValue(reg.registrationId);

    await this.loadSelectedContractor();

    this.selected.emit(this.entity.inputData);
  }

  async selectMyself() {
    if (this.isMyselfOptionDisabled) {
      if (this.contractorValueCtl.value === 'myself') {
        this.contractorValueCtl.setValue('');
      } else {
        this.contractorValueCtl.setValue(this.contractorValueCtl.value);
      }
      return;
    }

    this.entityCtl.enable();

    if (this.selectRegCtl) {
      this.selectRegCtl.enable();
    }

    if ((this.availableRegistrations?.length || 0) == 1) {
      const reg = this.availableRegistrations[0];
      await this.selectRegistration(reg);
    } else {
      this.entity.inputData.reset();
      this.contractor = null;
      this.entityCtl.setValue(null);
      if (this.selectRegCtl) {
        this.selectRegCtl.setValue(null);
      }
      this.contractorValueCtl.setValue('myself');
    }
  }

  ngOnDestroy(): void {
    if (this.entityForm) {
      this.form.removeControl('entityControls');
    }
  }

  async ngOnInit() {
    this.entityForm = new UntypedFormGroup({
      notInList: new UntypedFormControl('', Validators.nullValidator),
      registerContractorTypeId: new UntypedFormControl(
        '',
        Validators.nullValidator
      ),
      contractorValue: new UntypedFormControl('', Validators.required)
    });

    if (this.entity) {
      this.availableRegistrations = this.entity.availableRegistrations;
      this.contractorTypeDetails = this.entity.contractorTypeDetails;

      this.entity.contractorTypeDetails = null;
      this.entity.availableRegistrations = null;
      this.contractorTypeDropdownOptions = (this.entity.contractorTypeIds || []).map(ct => ({
        label: this.contractorTypeDetails?.[ct]?.name,
        value: ct
      }));
    }

    if ((this.availableRegistrations?.length || 0) > 1) {
      this.entityForm.addControl(
        'selectReg',
        new UntypedFormControl('', Validators.required)
      );
    }

    this.notInListCtl = this.entityForm.get('notInList');
    this.selectRegCtl = this.entityForm.get('selectReg');
    this.contractorValueCtl = this.entityForm.get('contractorValue');
    this.entityCtl = this.form.get(this.entity.templateCode);

    if (this.entity.isVisible) {
      this.form.addControl('entityControls', this.entityForm);
    }

    if (
      this.entity.inputData.selectedRegistrationId ||
      this.entity.inputData.notInList
    ) {
      if (this.entity.inputData.selectedRegistrationId) {
        this.entityCtl.setValue(this.entity.inputData.selectedRegistrationId);
      }

      if (
        this.availableRegistrations &&
        this.availableRegistrations?.some(
          e => e.registrationId == this.entity.inputData.selectedRegistrationId
        )
      ) {

         if (this.templateForPermitForm) {
          this.contractorRadioData = {
            ...this.contractorRadioData,
            value: 'myself'
          };
        }
        this.contractorValueCtl.setValue('myself');

        if (this.selectRegCtl) {
          this.selectRegCtl.setValue(
            this.entity.inputData.selectedRegistrationId
          );
        }
        await this.loadSelectedContractor();
      } else {

         if (this.templateForPermitForm) {
      this.contractorRadioData = {
        ...this.contractorRadioData,
        value: 'otherContractor'
      };
    }


        this.contractorValueCtl.setValue('otherContractor');
        if (this.entity.inputData.notInList) {
          this.notInListCtl.setValue(true);
          this.entityCtl.disable();
        } else {
          await this.loadContractors();
          await this.selectItem(this.entity.inputData.selectedRegistrationId);
        }
      }
    }

    this.searchTextChanged
      .pipe(debounceTime(400), distinctUntilChanged())

      .subscribe(model => {
        this.searchText = model;

        this.loadContractors();
      });

    this._securitySvc
      .isLoginEntitled(Actions.APPLY_ON_BEHALF_OF)
      .subscribe(result => {
        this.canApplyOnBehalfOf = result;
      });

    this.isMyselfOptionDisabled = !this.hasActiveRegistration();

    this.contractorRadioData = {
    ...this.contractorRadioData,
    options: [
      { label: 'Myself', value: 'myself', disabled: this.isMyselfOptionDisabled },
      { label: 'Other Contractor', value: 'otherContractor' }
    ]
  };

  }

  cancelCalculation(): void {
    super.cancelCalculation();

    if (this.entity.isVisible) {
      if (!this.form.get('entityControls')) {
        this.form.addControl('entityControls', this.entityForm);
      }
    } else {
      if (this.form.get('entityControls')) {
        this.form.removeControl('entityControls');
      }
    }
  }

  otherContractorSelected(checked) {
    this.contractorValueCtl.setValue('otherContractor');
    this.entity.inputData.reset();
    this.contractor = null;
    if (this.selectRegCtl) {
      this.selectRegCtl.setValue(null);
      this.selectRegCtl.disable();
    }
    this.entityCtl.setValue(null);
    if (this.registrations == null) {
      this.loadContractors();
    }
  }

  isContractorValue(value) {
    return this.contractorValueCtl.value == value;
  }

  hasActiveRegistration(): boolean {
    return (
      (this.availableRegistrations?.length || 0) > 0 &&
      this.availableRegistrations?.some(
        r =>
          r.status === RegistrationStatus.Approved ||
          r.status === RegistrationStatus.Renewed
      )
    );
  }

  clearSelection() {
    this.entityCtl.setValue(null);
    this.entity.inputData.reset();
    this.contractor = null;

    this.selected.emit(this.entity.inputData);
  }

  notInListChanged(e) {
    if (e.srcElement.checked) {
      this.clearSelection();
      this.entityCtl.disable();
    } else {
      this.entityCtl.enable();
    }
    this.entity.inputData.notInList = e.srcElement.checked;
  }

  async loadSelectedContractor() {
    let loadContractorObs: Observable<Contractor>;
    this.contractor = null;
    if (this.entity.inputData.selectedContractorId) {
      loadContractorObs = this._contractorSvc.getContractor(
        this.entity.inputData.selectedContractorId,
        false,
        false,
        false,
        false,
        this.context.isTestApplication
      );
    } else {
      loadContractorObs = of(null);
    }

    loadContractorObs.subscribe(c => {
      if (c != null && this.entity.inputData.selectedRegistrationId) {
        this.contractor = c;
      } else {
        this.entity.inputData.selectedContractorId = null;
        this.entity.inputData.selectedRegistrationId = null;
        this.contractor = null;
        this._toastr.error(
          'Selected contractor was not found.',
          'Missing Contractor',
          { timeOut: 5000 }
        );
      }
    });
  }

  async selectItem(value) {
    if (value) {
      this.entityCtl.setValue(value);
      this.entity.inputData.notInList = false;
      // get the information to display!
      if (this.registrations) {
        const reg = this.registrations.find(r => r.id === value);

        if (reg) {
          this.entity.inputData.selectedContractorId = reg.contractorID;

          this.entity.inputData.selectedRegistrationId = value;

          let businessname = '';

          businessname = reg.contractor.businessName;

          this.entity.inputData.selectedContractorBusinessName = businessname;
        }
      }
    } else {
      this.entityCtl.setValue(null);
    }

    await this.loadSelectedContractor();

    this.selected.emit(this.entity.inputData);
  }

  private getFilters(): ItemSearchOptionField[] {
    const filterOptions = [];

    filterOptions.push({
      title: 'status',
      options: [
        new ItemSearchOptionFieldOption({
          title: 'status',
          selected: true,
          filterText: '',
          searchText:
            RegistrationStatus.Approved + ',' + RegistrationStatus.Renewed,
          strOperator: 'in'
        })
      ]
    });

    const strToday = moment().format('MM/DD/YYYY');
    filterOptions.push({
      title: 'effectiveOn',
      options: [{ title: '', strOperator: '<=', filterText: strToday }]
    });
    filterOptions.push({
      title: 'expiresOn',
      options: [{ title: '', strOperator: '>=', filterText: strToday }]
    });

    filterOptions.push({
      title: 'closestExpiration',
      options: [{ title: '', strOperator: '', filterText: '' }]
    });

    if ((this.entity.contractorTypeIds?.length || 0) > 0) {
      filterOptions.push({
        title: 'ContractorTypeIds',
        options: [
          { title: '', filterText: this.entity.contractorTypeIds.join(',') }
        ]
      });
    }

    if (this.searchText) {
      filterOptions.push({
        title: 'contractor',
        options: [
          {
            title: '',
            filterText: this.searchText,
            searchOptionMethod: 'simpleSearch'
          }
        ]
      });
    }

    return filterOptions;
  }

  searchTextfieldData = {
    label: 'Search',
    placeholder: 'Search...',
    value: ''
  };


  onSearchTextChange(value: string) {
    this.entity.value = value;
    this.searchTextChanged.next(value);
  }

  @ViewChild('registerModal') registerModal!: any;
  registerModalData = {
    open: false,
    modalDescp: 'Register Contractor',
    modalSubDescp: '',
    yesNoBtn: true,
    closeBtn: false,
    okBtn: false,
    inTime: '300',
    outTime: '200'
  }
  openRegisterModal() {
    this.openRegister()
    this.registerModalData = { ...this.registerModalData, open: true };
  }

  closeRegisterModal() {
    this.registerModalData = { ...this.registerModalData, open: false };
  }


  @ViewChild('renewModal') renewModal!: any;
  renewModalData = {
    open: false,
    modalDescp: 'Renew Contractor',
    modalSubDescp: '',
    yesNoBtn: true,
    closeBtn: false,
    okBtn: false,
    inTime: '300',
    outTime: '200'
  };
  selectedRenewRegistration: any = null;

  openRenewModal(registration: any) {
    this.selectRegistration(registration);
    this.renewModalData = { ...this.renewModalData, open: true };
  }

  closeRenewModal() {
    this.renewModalData = { ...this.renewModalData, open: false };
    this.selectedRenewRegistration = null;
  }

  confirmRenew() {
    const regId = this.entity.inputData?.selectedRegistrationId;
    if (!regId) return;

    this.renewModalData = { ...this.renewModalData, open: false };
    this.renewRegistration(regId);
  }

onContractorTypeChange(value: string) {
  if (value === 'myself') {
    this.selectMyself();
  } else if (value === 'otherContractor') {
    this.otherContractorSelected(true);
  }

  this.contractorValueCtl.updateValueAndValidity();
}

  public setPage(pageNumber: number) {
    this.searching = true;
    this.registrations = null;
    this.pagination.pageNumber = pageNumber;
    this.loadContractors();
  }

  async loadContractors() {
    if (this.context.client) {
      const filterOptions = this.getFilters();

      this.searching = true;
      const results = await this._contractorSvc
        .searchContractorRegistrations(
          this.context.client.id,
          this.sortField,
          this.sortDescending,
          filterOptions,
          this.pagination.pageNumber,
          this.pagination.perPage,
          true,
          this.context.isTestApplication
        )
        .toPromise();

      this.searching = false;

      this.registrations = results.contractorRegistrations;
      this.pagination.pageCount = results.pageCount;

      this.entityCtl.setValue(this.entity.inputData.selectedRegistrationId);

      if (!this.entity.canEditContractor) {
        this.entityCtl.disable();
        this.notInListCtl.disable();
        await this.selectItem(this.entity.inputData.selectedRegistrationId);
      }
    }
  }
}
